import React from 'react';
import classNames from 'classnames';

import styles from './StatusBadge.module.scss';

export const statusBadgeTones = {
  success: 'success',
  default: 'default',
  error: 'error',
  warning: 'warning',
  info: 'info',
  purple: 'purple',
  orange: 'orange',
};

/**
 * Small status pill: optional leading icon + label, tone-colored fill and
 * border. Both the icon and label are centered against the badge's own
 * fixed height (not the text's line-height or the icon's intrinsic size),
 * so alignment stays correct regardless of font metrics or which icon a
 * caller passes in.
 */
export const StatusBadgeComponent = ({
  label,
  tone = statusBadgeTones.default,
  dot = false,
  icon,
  className,
}) => {
  if (dot) {
    return (
      <span
        className={classNames(
          styles.dotBadge,
          { [styles[`dotBadge_tone_${tone}`]]: tone },
          className
        )}
      >
        <span className={styles.dot} />
        <span className={styles.label}>{label}</span>
      </span>
    );
  }

  return (
    <span
      className={classNames(
        styles.badge,
        { [styles[`badge_tone_${tone}`]]: tone },
        className
      )}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.label}>{label}</span>
    </span>
  );
};

StatusBadgeComponent.displayName = 'StatusBadge';
